import { render, staticRenderFns } from "./VendorProfileReviews.vue?vue&type=template&id=1ac2c204"
import script from "./VendorProfileReviews.vue?vue&type=script&lang=js"
export * from "./VendorProfileReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports